import { getExecuteUrl } from '@/common/util/home/get-execute-url'

/**
 * 홈 데이터를 받아 카탈로그 엘리먼트 리스트에 있는
 * fetch url 을 반환
 * @param homeData
 * @returns {*|string}
 */
export const getFetchUrl = (homeData = {}) => {
  const [catalog] = homeData?.layout?.catalog?.catalogList ?? []
  return getExecuteUrl(catalog?.elementList)
}
